import { LogoWrapper } from './LogoStyle';

const Logo = () => {
  return (
    <LogoWrapper>
      <svg
        width='180'
        height='54'
        viewBox='0 0 180 54'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M13.048 27.128C13.048 25.1227 13.2613 23.1813 13.688 21.304C14.1573 19.4267 14.8827 17.7627 15.864 16.312C16.8453 14.8187 18.1253 13.6453 19.704 12.792C21.2827 11.896 23.2027 11.448 25.464 11.448C27.7253 11.448 29.6453 11.896 31.224 12.792C32.8027 13.6453 34.0827 14.8187 35.064 16.312C36.0453 17.7627 36.7493 19.4267 37.176 21.304C37.6453 23.1813 37.88 25.1227 37.88 27.128C37.88 29.048 37.6453 30.9253 37.176 32.76C36.7493 34.552 36.0453 36.1733 35.064 37.624C34.0827 39.0747 32.8027 40.248 31.224 41.144C29.6453 41.9973 27.7253 42.424 25.464 42.424C23.2027 42.424 21.2827 41.9973 19.704 41.144C18.1253 40.248 16.8453 39.0747 15.864 37.624C14.8827 36.1733 14.1573 34.552 13.688 32.76C13.2613 30.9253 13.048 29.048 13.048 27.128ZM3 27.128C3 30.456 3.512 33.5707 4.536 36.472C5.56 39.3307 7.032 41.8267 8.952 43.96C10.872 46.0933 13.2187 47.7787 15.992 49.016C18.808 50.2107 21.9653 50.808 25.464 50.808C29.0053 50.808 32.1627 50.2107 34.936 49.016C37.7093 47.7787 40.056 46.0933 41.976 43.96C43.896 41.8267 45.368 39.3307 46.392 36.472C47.416 33.5707 47.928 30.456 47.928 27.128C47.928 23.7147 47.416 20.5573 46.392 17.656C45.368 14.712 43.896 12.152 41.976 9.976C40.056 7.8 37.7093 6.09333 34.936 4.856C32.1627 3.61867 29.0053 3 25.464 3C21.9653 3 18.808 3.61867 15.992 4.856C13.2187 6.09333 10.872 7.8 8.952 9.976C7.032 12.152 5.56 14.712 4.536 17.656C3.512 20.5573 3 23.7147 3 27.128Z'
          fill='currentColor'
        />
        <path
          d='M54.7965 4.088V49.784H64.2045V19.192H64.3325L83.3405 49.784H93.3885V4.088H83.9805V34.744H83.8525L64.7805 4.088H54.7965Z'
          fill='currentColor'
        />
        <path
          d='M102.234 4.088V49.784H134.554V41.336H112.282V4.088H102.234Z'
          fill='currentColor'
        />
        <path
          d='M144.886 31.992V49.784H154.934V32.248L171.895 4.088H160.694L150.07 22.136L139.382 4.088H128.118L144.886 31.992Z'
          fill='currentColor'
        />
        <path
          d='M166.283 39.928V49.784H176.331V39.928H166.283Z'
          fill='currentColor'
        />
      </svg>
    </LogoWrapper>
  );
};

export default Logo;
